export default "__VITE_ASSET__d1bce806__"